import { skipToken, useQuery } from '@tanstack/react-query'
import type { SettingsApiFindPortalSettingsRequest } from '@itsrever/rever-api'
import { setSettings, settingsApi } from '@/redux/api/settings-api-slice'
import { useAppDispatch } from '@/redux/hooks'

const fontByGroup: Record<string, string> = {
  misako: 'Inter',
  hoff: 'Neue Haas'
}

export const useSettings = ({ slug }: SettingsApiFindPortalSettingsRequest) => {
  const dispatch = useAppDispatch()

  return useQuery({
    queryKey: ['settings', slug],
    queryFn: slug
      ? async () => {
          const { data } = await settingsApi.findPortalSettings({
            slug
          })

          dispatch(setSettings(data))

          const group = data?.ecommerce_group ?? ''

          document.documentElement.style.setProperty(
            '--font-primary',
            fontByGroup[group] ?? 'Roobert'
          )

          if (data?.branding?.title) {
            document.title = data?.branding?.title
          }

          if (data?.branding?.favicon_url) {
            const oldFavicon = document.getElementById('dynamic-favicon')
            if (oldFavicon) document.head.removeChild(oldFavicon)

            const favicon = document.createElement('link')
            favicon.id = 'dynamic-favicon'
            favicon.rel = 'shortcut icon'
            favicon.href = data?.branding?.favicon_url
            document.head.appendChild(favicon)
          }

          return data
        }
      : skipToken,
    staleTime: Infinity
  })
}
